export const scrollListItemIntoView = (element: HTMLElement, isSelectedIndex: boolean) => {
    if (element && isSelectedIndex) {
        element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
};
